import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import Navbar8 from '../components/navbar8'
import ContentList6 from '../components/content-list6'
import Footer4 from '../components/footer4'
import './dei-policy.css'

const DEIPolicy = (props) => {
  return (
    <div className="dei-policy-container">
      <Helmet>
        <title>DEI-Policy - Allstream Global Business Solutions</title>
        <meta
          name="description"
          content='"Streamline your business with Allstream – expert Business Setup, HR, Finance, IT, and Admin support for fast, hassle-free growth."'
        />
        <meta
          property="og:title"
          content="DEI-Policy - Allstream Global Business Solutions"
        />
        <meta
          property="og:description"
          content='"Streamline your business with Allstream – expert Business Setup, HR, Finance, IT, and Admin support for fast, hassle-free growth."'
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/231f249b-b608-4355-8168-0f58a5abbd5a/0c40ed70-952b-4901-8fa3-40ab70c3e200?org_if_sml=1&amp;force_format=original"
        />
      </Helmet>
      <Navbar8
        link1={
          <Fragment>
            <span className="dei-policy-text10">#About Us</span>
          </Fragment>
        }
        link2={
          <Fragment>
            <span className="dei-policy-text11">#Why Us</span>
          </Fragment>
        }
        link3={
          <Fragment>
            <span className="dei-policy-text12">#</span>
          </Fragment>
        }
        link4={
          <Fragment>
            <span className="dei-policy-text13">#</span>
          </Fragment>
        }
        page1={
          <Fragment>
            <span className="dei-policy-text14">Home</span>
          </Fragment>
        }
        page2={
          <Fragment>
            <span className="dei-policy-text15">About Us</span>
          </Fragment>
        }
        page3={
          <Fragment>
            <span className="dei-policy-text16">Services</span>
          </Fragment>
        }
        page4={
          <Fragment>
            <span className="dei-policy-text17">Contact</span>
          </Fragment>
        }
        action1={
          <Fragment>
            <span className="dei-policy-text18">Contact Us</span>
          </Fragment>
        }
        action2={
          <Fragment>
            <span className="dei-policy-text19">Secondary Action</span>
          </Fragment>
        }
        logoSrc="/logo-1500h.png"
        page1Description={
          <Fragment>
            <span className="dei-policy-text20">Page One Description</span>
          </Fragment>
        }
        page2Description={
          <Fragment>
            <span className="dei-policy-text21">Page Two Description</span>
          </Fragment>
        }
        page3Description={
          <Fragment>
            <span className="dei-policy-text22">Page Three Description</span>
          </Fragment>
        }
        page4Description={
          <Fragment>
            <span className="dei-policy-text23">Page Four Description</span>
          </Fragment>
        }
      ></Navbar8>
      <ContentList6
        content2={
          <Fragment>
            <span className="dei-policy-text24">
              At Allstream Global, we are committed to building an inclusive and
              equitable workplace that respects and values diverse backgrounds
              and perspectives. This policy applies to all employees, partners,
              clients, and vendors.
            </span>
          </Fragment>
        }
        content9={
          <Fragment>
            <span className="dei-policy-text25">
              This policy is reviewed annually by our DEI committee and updated
              as needed to reflect current best practices.
            </span>
          </Fragment>
        }
        heading7={
          <Fragment>
            <span className="dei-policy-text26">
              Allstream Global DEI Policy Statement
            </span>
          </Fragment>
        }
        heading8={
          <Fragment>
            <span className="dei-policy-text27">1. Purpose &amp; Scope</span>
          </Fragment>
        }
        heading9={
          <Fragment>
            <span className="dei-policy-text28">9. Review &amp; Updates</span>
          </Fragment>
        }
        content21={
          <Fragment>
            <span className="dei-policy-text29">
              We expect our suppliers and vendors to align with our DEI
              standards and support local initiatives promoting inclusion.
            </span>
          </Fragment>
        }
        content22={
          <Fragment>
            <span className="dei-policy-text30">
              We collect and monitor DEI metrics annually and embed diversity
              goals into leadership evaluations.
            </span>
          </Fragment>
        }
        content23={
          <Fragment>
            <span className="dei-policy-text31">
              We provide clear grievance procedures and protect individuals who
              raise concerns. Violations are met with strict consequences.
            </span>
          </Fragment>
        }
        content24={
          <Fragment>
            <span className="dei-policy-text32">
              We require all employees to undergo unconscious bias training, and
              managers receive additional training in inclusive leadership and
              equitable evaluations.
            </span>
          </Fragment>
        }
        content25={
          <Fragment>
            <span className="dei-policy-text33">
              We utilize structured interviews, inclusive job descriptions, and
              ensure diverse hiring panels. We proactively seek candidates from
              underrepresented groups.
            </span>
          </Fragment>
        }
        content26={
          <Fragment>
            <span className="dei-policy-text34">
              We hire, develop, and promote based on merit. We maintain a
              zero-tolerance stance toward discrimination and bias. Our
              leadership team reflects our commitment to diversity, with 45% of
              roles held by women.
            </span>
          </Fragment>
        }
        content27={
          <Fragment>
            <span className="dei-policy-text35">
              <span className="dei-policy-text36">Diversity:</span>
              <span>
                {' '}
                Representation across race, gender, age, nationality, abilities,
                and more.
              </span>
              <br></br>
              <span className="dei-policy-text39">
                Equity:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>
                Ensuring fair access, opportunity, and advancement for all.
              </span>
              <br></br>
              <span className="dei-policy-text42">Inclusion:</span>
              <span>
                {' '}
                Creating a culture where all individuals feel respected,
                accepted, and valued.
              </span>
            </span>
          </Fragment>
        }
        heading81={
          <Fragment>
            <span className="dei-policy-text44">
              8. Supplier &amp; Community Engagement
            </span>
          </Fragment>
        }
        heading82={
          <Fragment>
            <span className="dei-policy-text45">
              7. Accountability &amp; Monitoring
            </span>
          </Fragment>
        }
        heading83={
          <Fragment>
            <span className="dei-policy-text46">
              6. Zero Tolerance for Discrimination
            </span>
          </Fragment>
        }
        heading84={
          <Fragment>
            <span className="dei-policy-text47">
              <span>5. Training &amp; Education</span>
              <br></br>
            </span>
          </Fragment>
        }
        heading85={
          <Fragment>
            <span className="dei-policy-text50">
              4. Recruitment &amp; Hiring Practices
            </span>
          </Fragment>
        }
        heading86={
          <Fragment>
            <span className="dei-policy-text51">3. Our Commitment</span>
          </Fragment>
        }
        heading87={
          <Fragment>
            <span className="dei-policy-text52">2. Definitions</span>
          </Fragment>
        }
      ></ContentList6>
      <Footer4
        link1={
          <Fragment>
            <span className="dei-policy-text53">About Us</span>
          </Fragment>
        }
        link2={
          <Fragment>
            <span className="dei-policy-text54">Services</span>
          </Fragment>
        }
        link3={
          <Fragment>
            <span className="dei-policy-text55">Contact US</span>
          </Fragment>
        }
        link4={
          <Fragment>
            <span className="dei-policy-text56">DEI Policy</span>
          </Fragment>
        }
        termsLink={
          <Fragment>
            <span className="dei-policy-text57">Terms of Service</span>
          </Fragment>
        }
        cookiesLink={
          <Fragment>
            <span className="dei-policy-text58">Cookies Settings</span>
          </Fragment>
        }
        privacyLink={
          <Fragment>
            <span className="dei-policy-text59">Privacy Policy</span>
          </Fragment>
        }
      ></Footer4>
    </div>
  )
}

export default DEIPolicy
